import productImage1 from './images/image-product-1.jpg'
import productImage2 from './images/image-product-2.jpg'
import productImage3 from './images/image-product-3.jpg'
import productImage4 from './images/image-product-4.jpg'

export const data = [productImage1, productImage2, productImage3, productImage4]